<template>
  <b-modal
    :active="displayModal"
    has-modal-card
    @close="$emit('close')"
    :can-cancel="['escape', 'x', 'outside']"
  >
    <div class="dialog" style="width: 800px; height: auto">
      <div class="modal-card" style="max-width: 100%">
        <form @submit.prevent="validateBeforeSubmit">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ modalTitle }}</p>
          </header>
          <section class="modal-card-body">
            <b-notification :closable="false">
              {{ $t('compCarbonFormsDevicesModal.info-1') }}
            </b-notification>
            <b-notification :closable="false">
              <div class="columns">
                <div class="column">
                  <b-field
                    :label="$t('compCarbonFormsDevicesModal.field-1')"
                    :type="{ 'is-danger': errors.has('type') }"
                    :message="errors.first('type')"
                  >
                    <b-select
                      name="type"
                      v-validate="'required'"
                      v-model="citem.type"
                      :placeholder="$t('compCarbonFormsDevicesModal.field-1')"
                      :disabled="isSubmitted"
                      expanded
                    >
                      <option
                        v-for="(item, key) in devices"
                        :key="key"
                        :value="key"
                      >
                        {{ i18nType(key) }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
                <div class="column">
                  <b-field
                    :label="$t('compCarbonFormsDevicesModal.field-2')"
                    :type="{ 'is-danger': errors.has('model') }"
                    :message="errors.first('model')"
                  >
                    <b-select
                      name="model"
                      v-model="citem.model"
                      expanded
                      v-validate="{ required: hasModels }"
                      :placeholder="$t('compCarbonFormsDevicesModal.field-2')"
                      :disabled="isSubmitted || !hasModels"
                    >
                      <option v-if="addDefault" value="default">
                        {{ $t('labels.default_model') }}
                      </option>
                      <option
                        v-for="(item, key) in models"
                        :key="key"
                        :value="key"
                      >
                        {{ i18nModel(key) }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
                <div class="column">
                  <b-field
                    :label="$t('compCarbonFormsDevicesModal.field-3')"
                    :type="{ 'is-danger': errors.has('amount') }"
                    :message="errors.first('amount')"
                  >
                    <b-input
                      name="amount"
                      :disabled="isSubmitted"
                      v-model.number="citem.amount"
                      v-validate="'required|numeric'"
                      type="number"
                      min="0"
                      max="99999"
                      step="1"
                    />
                  </b-field>
                </div>
              </div>
            </b-notification>
            <b-notification v-if="authStore.isAuthenticated" :closable="false">
              <tags-input v-model="citem.tags" :disabled="isSubmitted" />
            </b-notification>
          </section>
          <footer class="modal-card-foot">
            <b-button class="button" @click="$emit('close')" icon-left="close">
              {{ $t('cancel') }}
            </b-button>
            <button
              v-show="modeCreation"
              type="submit"
              class="button is-primary"
            >
              <b-icon icon="plus" />
              <span> {{ $t('add') }} </span>
            </button>
            <button
              v-show="!modeCreation"
              type="submit"
              class="button is-primary"
            >
              <b-icon icon="refresh" />
              <span> {{ $t('update') }} </span>
            </button>
          </footer>
        </form>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { devices, i18nType, i18nModel } from '@ecodiag/ecodiag-lib'
import { useAuthenticationStore } from '@/stores/authentication.js'
import { useGHGIStore } from '@/stores/ghgi.js'

import _ from 'lodash'

export default {
  name: 'Modal',
  props: {
    displayModal: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: function () {
        return {}
      }
    },
    modeCreation: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'tags-input': () => import('@/components/core/TagsInput.vue')
  },
  data () {
    return {
      // avoid mutation of the original
      citem: _.cloneDeep(this.item)
    }
  },
  setup () {
    const ghgiStore = useGHGIStore()
    const authStore = useAuthenticationStore()
    return { ghgiStore, authStore }
  },
  $_veeValidate: {
    validator: 'new'
  },
  computed: {
    devices () {
      return devices
    },
    hasModels () {
      return (
        this.citem.type in this.devices &&
        'models' in this.devices[this.citem.type]
      )
    },
    models () {
      if (this.hasModels) {
        return this.devices[this.citem.type].models
      } else {
        return {}
      }
    },
    isSubmitted: function () {
      return this.ghgiStore.item.isSubmitted
    },
    addDefault () {
      let hasDefault =
        this.hasModels && 'default' in this.devices[this.citem.type].models
      return !hasDefault || !this.hasModels
    },
    modalTitle () {
      return this.modeCreation
        ? this.$t('compCarbonFormsDevicesModal.title-1')
        : this.$t('compCarbonFormsDevicesModal.title-2')
    }
  },
  methods: {
    i18nType (type) {
      return i18nType(type, this.$i18n.locale)
    },
    i18nModel (model) {
      let t = i18nModel(this.citem.type, model, this.$i18n.locale)
      if (t === '__default__') {
        return this.$t('labels.default_model')
      }
      return t
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit('validated', this.citem)
        }
      })
    }
  }
}
</script>
